var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOuterlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00016 0.583344C4.25952 0.583344 2.84597 0.926878 1.8865 1.88635C0.927031 2.84582 0.583496 4.25937 0.583496 6.00001V10C0.583496 11.7406 0.927031 13.1542 1.8865 14.1137C2.84597 15.0731 4.25952 15.4167 6.00016 15.4167H10.0002C11.7408 15.4167 13.1544 15.0731 14.1138 14.1137C15.0733 13.1542 15.4168 11.7406 15.4168 10V8.66668C15.4168 8.25246 15.081 7.91668 14.6668 7.91668C14.2526 7.91668 13.9168 8.25246 13.9168 8.66668V10C13.9168 11.5927 13.5937 12.5125 13.0532 13.053C12.5126 13.5935 11.5929 13.9167 10.0002 13.9167H6.00016C4.40747 13.9167 3.48769 13.5935 2.94716 13.053C2.40663 12.5125 2.0835 11.5927 2.0835 10V6.00001C2.0835 4.40732 2.40663 3.48754 2.94716 2.94701C3.48769 2.40648 4.40747 2.08334 6.00016 2.08334H7.3335C7.74771 2.08334 8.0835 1.74756 8.0835 1.33334C8.0835 0.91913 7.74771 0.583344 7.3335 0.583344H6.00016Z",
    fill: "#011235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7168 1.33334C10.7168 0.91913 11.0526 0.583344 11.4668 0.583344H14.6668C15.081 0.583344 15.4168 0.91913 15.4168 1.33334V4.53334C15.4168 4.94756 15.081 5.28334 14.6668 5.28334C14.2526 5.28334 13.9168 4.94756 13.9168 4.53334V3.1437L9.19683 7.86367C8.90394 8.15656 8.42907 8.15656 8.13617 7.86367C7.84328 7.57077 7.84328 7.0959 8.13617 6.80301L12.8558 2.08334H11.4668C11.0526 2.08334 10.7168 1.74756 10.7168 1.33334Z",
    fill: "#011235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOuterlink);
export default __webpack_public_path__ + "static/media/outer link.969dee8e7fafe8d840d09bd3dc8908b5.svg";
export { ForwardRef as ReactComponent };